function handleErr(setMessage, consoleMsg) {
    setMessage({ type: 'error', text: 'Não foi possível completar a requisição.' });
    console.log(consoleMsg);
}

function formatPhonePt(value) {
  if (!value) return "";

  const digits = value.replace(/\D/g, "");

  const phone = digits.startsWith("351")
    ? digits.slice(3)
    : digits;

  return `+351 ${phone.slice(0, 1)}${phone.slice(1, 3)} ${phone.slice(3, 6)} ${phone.slice(6, 9)}`.trim();
}

function parseApiDateTime(value) {
  if (typeof value !== 'string')
    return Number.NaN;

  const normalizedValue = value.trim();
  if (!normalizedValue)
    return Number.NaN;

  const directParsed = Date.parse(normalizedValue);
  if (!Number.isNaN(directParsed))
    return directParsed;

  // Handles timestamps with microseconds by trimming to milliseconds.
  const match = normalizedValue.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d+))?(Z)?$/);
  if (!match)
    return Number.NaN;

  const [, base, fraction = '0', zulu = ''] = match;
  const milliseconds = fraction.padEnd(3, '0').slice(0, 3);

  return Date.parse(`${base}.${milliseconds}${zulu}`);
}

export { handleErr, formatPhonePt, parseApiDateTime };